<template>
  <card-container
    :id="pageId"
    :is-loading="isLoading"
    :loading-message="`Adding $${requestBody.rideCredits} to Customer...`"
    :disabled="!isPhoneNumberValid || isLoading"
    @submit="submitForm"
    @reset="resetForm"
  >
    <template #title>
      Add Partner Caller Credits
    </template>

    <template #content>
      <div
        v-if="!isPartnerDashboard"
        class="row align-items-center"
      >
        <label class="col-sm-3 control-label"> Partner Code* </label>
        <div class="col-sm-8">
          <sanitized-input
            id="partnerCode"
            v-model="requestBody.partnerCode"
            placeholder="Please input partner code"
            required
          />
        </div>
      </div>
      <div class="row align-items-center">
        <label class="col-sm-3 control-label"> Phone Number* </label>
        <phone-number-input
          v-model="requestBody.phoneNumber"
          class="col-sm-8"
          :required="true"
        />
      </div>
      <div class="row align-items-center">
        <label class="col-sm-3 control-label"> Amount* </label>
        <div class="col-sm-5">
          <el-input
            :id="`amount-${pageId}`"
            v-model="requestBody.rideCredits"
            min="0.01"
            type="number"
            step="0.01"
            required
          >
            <template #prepend>
              $
            </template>
          </el-input>
        </div>
      </div>

      <div class="row">
        <label class="col-sm-3 control-label pt-5"> Notes* </label>
        <div class="col-sm-8">
          <sanitized-textarea
            :id="`notes-${pageId}`"
            v-model="requestBody.notes"
            placeholder="Please note the reason for the credit."
            autosize
            required
          />
        </div>
      </div>
    </template>
  </card-container>
</template>

<script setup lang="ts">
import { ref, reactive, computed, watch } from 'vue';

import util from '@/Utils/util';
import { useCustomer } from '@/use/customer';
import { useSwalDialog } from '@/use/swalDialog';
import { usePartner } from '@/use/partner';
import { useDashboard } from '@/use/app';
import { addPartnerCallerCredits } from '@/services/partnerCaller/addPartnerCallerCredits';

const pageId = 'add-partner-caller-credits';

const { customerPhoneNumber } = useCustomer();
const { showSuccessPopupDialog, showErrorPopupDialog } = useSwalDialog();
const { isPartnerDashboard } = useDashboard();
const { partnerCode } = usePartner();

const requestBody = reactive({
  partnerCode: '',
  phoneNumber: '',
  rideCredits: 0,
  notes: '',
});
const isLoading = ref(false);

const isPhoneNumberValid = computed(() => util.isPhoneNumberValid(requestBody.phoneNumber));

const submitForm = async () => {
  isLoading.value = true;
  try {
    await addPartnerCallerCredits({
      partnerCode: requestBody.partnerCode,
      phoneNumber: requestBody.phoneNumber,
      rideCredits: Number(requestBody.rideCredits),
      notes: requestBody.notes,
    });

    showSuccessPopupDialog({
      text: 'The partner caller credits have been added successfully',
    });

    resetForm();
  } catch (error) {
    const errorText = util.getGraphqlError(error, false);
    showErrorPopupDialog({
      text: errorText,
    });
  }
  isLoading.value = false;
};

const resetForm = () => {
  (requestBody.partnerCode = isPartnerDashboard.value ? partnerCode.value : ''),
    (requestBody.phoneNumber = customerPhoneNumber.value || '');
  requestBody.rideCredits = 0;
  requestBody.notes = '';
};

watch(customerPhoneNumber, resetForm, {
  immediate: true,
});
</script>
